import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation } from '@tanstack/react-query'

/** Fetches the PDF and opens it in a new tab. */
export function useSettlementPdf() {
  const toast = useToast()
  const onError = useOnError()

  async function getPdf(id: string) {
    const response = await apiClient.get(SNA_PREFIX + `settlements/${id}/pdf`, {
      responseType: 'blob'
    })
    return response.data as Blob
  }

  return useMutation({
    mutationFn: getPdf,
    onSuccess: (blob) => {
      const url = URL.createObjectURL(blob)
      const opened = window.open(url, '_blank')
      if (!opened) {
        toast.error({ message: 'Popup blocked' })
      }
      // Revoke once the new tab has had a chance to load it.
      setTimeout(() => URL.revokeObjectURL(url), 60_000)
    },
    onError
  })
}
